import { DEFAULT_PARTNER_MARGIN, FINANCIAL_STRUCTURE, TRANSACTION_COSTS } from '@/constants/locales/calculator';
import { ScenarioInputs, ScenarioType } from '@/types/scenario';
import { TransferPair } from '@/types/transfer-pair';

export const calculateScenario = (type: ScenarioType, data: TransferPair, inputs: ScenarioInputs) => {
  const exchangeRate =
    inputs.invoicingCurrency.toLowerCase() === data.originCurrencyISO.toLowerCase() || type === 'internationalInvoicing'
      ? 1
      : data.exchangeRate;
  const localInvoicingAmount = (inputs.invoicingAmount ?? 0) * exchangeRate;

  const vatRate = type === 'internationalInvoicing' ? 0 : data.vatRate;
  const vatAmount = localInvoicingAmount * vatRate;

  const nonRecTaxes = type === 'internationalInvoicing' || type === 'localPartner' ? 0 : data.nonRecTaxes;
  const nonRecTaxesAmount = localInvoicingAmount * nonRecTaxes;

  const partnerMargin =
    type === 'localPartner'
      ? (inputs.sellThroughLocalPartner ? (inputs.partnerMargin ?? 0) : DEFAULT_PARTNER_MARGIN) / 100
      : type === 'alsoThere'
        ? 0.2
        : 0;
  const partnerMarginAmount = localInvoicingAmount * partnerMargin;
  const financialStructure = type === 'localSubsidiary' ? FINANCIAL_STRUCTURE * exchangeRate : 0;

  const whtAmount = localInvoicingAmount * data.wht;
  const transactionCost = type === 'alsoThere' ? TRANSACTION_COSTS * exchangeRate : 0;

  const paymentAmountToReceive =
    localInvoicingAmount - nonRecTaxesAmount - whtAmount - transactionCost - partnerMarginAmount - financialStructure;
  const paymentAmountToReceiveUSD =
    type === 'internationalInvoicing' ? paymentAmountToReceive : paymentAmountToReceive / data.exchangeRate;

  return {
    exchangeRate,
    localInvoicingAmount,
    vatRate,
    vatAmount,
    nonRecTaxes,
    nonRecTaxesAmount,
    partnerMargin,
    partnerMarginAmount,
    financialStructure,
    whtAmount,
    transactionCost,
    paymentAmountToReceive,
    paymentAmountToReceiveUSD,
  };
};
